import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import Chart from './Chart'
import ComplianceTypeDropdown from '../../_shared/ComplianceTypeDropdown'
import NonCompliancesCounterLoader from './_load/NonCompliancesCounterLoader'
import PeriodDescription from '../../_shared/PeriodDescription'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import WidgetWrapper from '../../WidgetWrapper'

const ServiceOrdersByStatusWidget = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Grid justify="space-between" gap={1}>
        <Col>
          <Title size="h5" noMargin>
            {widget.name}
          </Title>
          <PeriodDescription />
        </Col>
        <Col flex={1} />
        <ComplianceTypeDropdown />
      </Grid>

      <Separator weight={6} />
      <NonCompliancesCounterLoader>
        <Chart widget={widget} />
      </NonCompliancesCounterLoader>
    </WidgetWrapper>
  )
}

export default ServiceOrdersByStatusWidget
